import React from 'react';

function About() {
  return (
    <main className="page-content">
      <section className="page-hero">
        <h1>About Us</h1>
        <p>Get to know the band behind the music</p>
      </section>

      <section className="band-story">
        <div className="story-content">
          <div className="band-photo">
            <div className="image-placeholder">Band Photo</div>
          </div>
          <div className="story-text">
            <h2>Our Story</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</p>
            <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
          </div>
        </div>
      </section>

      <section className="band-members">
        <h2>Band Members</h2>
        <div className="members-grid">
          <div className="member-card">
            <div className="image-placeholder">Member Photo</div>
            <h3>Member Name</h3>
            <p>Instrument/Role</p>
          </div>
          <div className="member-card">
            <div className="image-placeholder">Member Photo</div>
            <h3>Member Name</h3>
            <p>Instrument/Role</p>
          </div>
          <div className="member-card">
            <div className="image-placeholder">Member Photo</div>
            <h3>Member Name</h3>
            <p>Instrument/Role</p>
          </div>
        </div>
      </section>

      <section className="behind-scenes">
        <h2>Behind the Scenes</h2>
        <div className="videos-grid">
          <div className="video-placeholder">
            <p>Embedded Behind-the-Scenes Video</p>
            <p>Studio Sessions</p>
          </div>
          <div className="video-placeholder">
            <p>Embedded Interview Video</p>
            <p>Band Interview</p>
          </div>
        </div>
      </section>

      <section className="social-media">
        <h2>Follow Our Journey</h2>
        <div className="social-grid">
          <div className="social-platform">
            <h3>Instagram</h3>
            <div className="social-placeholder">
              <p>Embedded Instagram Feed</p>
              <a href="https://instagram.com/bandname" target="_blank" rel="noopener noreferrer" className="social-link">@bandname</a>
            </div>
          </div>
          <div className="social-platform">
            <h3>TikTok</h3>
            <div className="social-placeholder">
              <p>Embedded TikTok Videos</p>
              <a href="https://tiktok.com/@bandname" target="_blank" rel="noopener noreferrer" className="social-link">@bandname</a>
            </div>
          </div>
          <div className="social-platform">
            <h3>YouTube</h3>
            <div className="social-placeholder">
              <p>Embedded YouTube Channel</p>
              <a href="https://youtube.com/@bandname" target="_blank" rel="noopener noreferrer" className="social-link">Subscribe</a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default About;